const createReaction = (input) => `
mutation MyMutation2 {
    createReaction(input: ${input}) {
        postID
        id
    }
}`;

export default createReaction;
